import React from "react";
import { createRoot } from "react-dom/client";
import { StylesProvider, createGenerateClassName } from "@mui/styles";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
// polyfills
import "fast-text-encoding";
import "to-blob";
// Limitless imports
import { initLogger, log } from "@limitless/common/utils/Logging";
import ClientContext from "@limitless/common/utils/client-context/ClientContext";
import { PORTAL_RESOURCES } from "@limitless/common/apis/resource-api/RemoteResourceUtil";
import { PortalContextProvider } from "../../../expert";
import { createUserPool } from "../../../expert/apis/authentication-api/AuthenticationAPI";
import { getUsersPreviousLocale } from "../SecureUserValidation";
export const loadPortalApplication = config => {
  const {
    PortalApp,
    productionPrefix,
    appName,
    rootElement = "root",
    resourceList = PORTAL_RESOURCES,
    configItems,
    defaultContentMap = {},
    disableWebSockets,
    appAccessPolicy
  } = config;

  // Create a unique prefix for the production build inline CSS classes
  const generateClassName = createGenerateClassName({
    productionPrefix
  });

  // Setting up the app_name to fetch S3 contents based on the application
  // Also used by the State Engine to only generate manager state for comm man
  ClientContext._appName = appName;

  // Load the tenant / api key / group / locale from div
  ClientContext.validateConfig(rootElement);
  const previousLocale = getUsersPreviousLocale();
  initLogger();
  // Create the cognito user pool for the given environment variables.
  createUserPool();
  log.info(`Loading ${process.env.REACT_APP_NAME} version ${process.env.REACT_APP_VERSION}....`);
  const container = document.getElementById(rootElement);
  const root = createRoot(container);
  root.render(/*#__PURE__*/React.createElement(StylesProvider, {
    generateClassName: generateClassName
  }, /*#__PURE__*/React.createElement(PortalContextProvider, {
    configItems: configItems,
    disableWebSockets: disableWebSockets,
    resourceList: resourceList,
    applicationName: appName,
    defaultContentMap: defaultContentMap,
    previousLocale: previousLocale,
    appAccessPolicy: appAccessPolicy
  }, /*#__PURE__*/React.createElement(PortalApp, null))));
};